import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { SyncManagerButtonComponent } from "./sync-manager-button.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule
    ],
    declarations: [
        SyncManagerButtonComponent
    ],
    exports: [
        SyncManagerButtonComponent
    ]
})
export class SyncManagerButtonModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-other/sync-manager-button/sync-manager-button.module.ts